angular.module('gym.contacts').factory('ContactFlagsService', ["$modal", function($modal) {
  return {
    editFlag: function(contact, id) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/gyms/contacts/flags/edit_flag_modal.html.slim'),
        controller: 'EditFlagCtrl',
        resolve: {
          contact: function() {
            return contact;
          },
          flag: function() {
            return contact.one('flags', id).get();
          }
        }
      });
      return modalInstance.result;
    },
    showFlags: function(contact, id) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/gyms/contacts/flags/show_flags_modal.html.slim'),
        controller: 'ShowFlagsCtrl',
        size: 'lg',
        resolve: {
          contact: function() {
            return contact;
          }
        }
      });
      return modalInstance.result;
    }
  };
}]);
